// src/stone/icons/Pounds.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Pounds = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 23",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "currentcolor",
          d: "M11.954 3.435c0-.157-.02-1.002-.684-1.691a2.32 2.32 0 0 0-1.656-.7H4.843c-2.115 0-3.821 1.744-3.821 3.905v7.35c0 2.735 2.166 4.948 4.843 4.948h1.4M4.73 1.587v3.289"
        }
      ),
      /* @__PURE__ */ jsx("path", { stroke: "currentcolor", d: "M8.296 1.524v3.289" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "currentcolor",
          d: "m11.525 14.063.51-.522v6.024c0 1.326 1.053 2.39 2.34 2.39h4.772c2.115 0 3.821-1.743 3.821-3.904v-7.35c0-2.735-2.166-4.948-4.843-4.948h-4.2l-6.66 7.746.725.668a2.527 2.527 0 0 0 3.525-.104zM19.27 21.413v-3.289M15.704 21.476v-3.289"
        }
      )
    ]
  }
);
var Pounds_default = Pounds;

export {
  Pounds_default
};
